 <template>
 <div v-role="'func'" style="margin-top:5px;">
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

     <div v-if="false">

           <v-card
    class="mx-auto"
    outlined
  >
  <div class="text-center">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">Bloqueada</v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  </div>

  </v-card>
     </div>
 <div v-if="true">
  <v-data-table
    :headers="headers"
    :items="funcionarios"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Funcionário

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>
         <div class="flex-grow-1"></div>
         <v-row>
        <v-col class="text-center" cols="4" ><v-btn style="margin-top:15px;" x-large fab dark color="primary" @click="dialog=true">
              <v-icon dark>add</v-icon>
            </v-btn></v-col>
      </v-row>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

       
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>
               <v-progress-circular
                    v-if="progresso"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col v-if="false" cols="12" sm="12" md="6">
                      <v-text-field

                        v-model="editedItem.idFuncionario"
                        label="cod"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                      <v-text-field

                        v-model="editedItem.nome"
                        label="Nome"
                         :rules="obrigqtorioRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                       <v-text-field

                        v-model="editedItem.idPEssoa"
                         :rules="ruleBI"
                         v-mask="mascara"
                        :label="descricao"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch v-model="dense" @change="outroDoc()"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.email"
                        label="Email"
                        :rules="ruleEmailRequired"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.telefone"
                         :rules="obrigqtorioRules"
                        label="Telefone"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid) || progresso
                "
                text
                @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    text: '',
    flag_curso: '',
    formValid: true,
    progresso: false,
    mascara: '#########-AA-###',
    usuarios: [],
    isLoading: false,
    search: '',
    descricao:'Bilhete',
    cursos: [],
    usuariosJaExistentes: [],
    obrigqtorioRules: [
      value => !!value || 'campo obrigatório.'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],

    funcionarios: [],
    dialog: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'B.I', value: 'bi' },
      { text: 'Email', value: 'email' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idFuncionario: '',
      idPEssoa: '', // bi
      i_id: '', // idinstituicao
      email: '',
      nome: '',
      telefone: ''
    },
    defaultItem: {
      idFuncionario: '',
      idPEssoa: '', // bi
      i_id: '', // idinstituicao
      email: '',
      nome: '',
      telefone: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Funcionário' : 'Editar'
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    //this.initialize()

    console.log(new Date())
  },

  methods: {

    async CarregaUsuarios (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }

        this.usuarios = await axios
          .get('/usuarioFindAll/' + payload)
          .then(res => res.data)
        console.log(this.usuarios[this.usuarios.length - 1])
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initialize (search) {
      this.isLoading = true
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }

        this.funcionarios = await axios
          .get('/funcionarioFindAll/' + payload)
          .then(res => res.data).then(this.CarregaUsuarios())

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.funcionarios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.funcionarios.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
      this.funcionarios.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    outroDoc()
    {
         if( this.descricao === 'Bilhete')
         {
             this.editedItem.idPEssoa = ''
             this.descricao = 'Outro Doc.'
             this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
             this.ruleBI = 
               [
                   value => value.length >= 16 && value.length <=30 || 'Minimo de caracteres exigido( 16 )'
               ]
             
         }
         else
         {
              this.editedItem.idPEssoa = ''
              this.descricao = 'Bilhete'
              this.mascara = '#########-AA-###'
              ruleBI: 
                  [
                     value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
                  ]
         }

    },

    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true

        try {
          var params = {
            idFuncionario: this.editedItem.idFuncionario,
            nome: this.editedItem.nome,

            idPEssoa: this.editedItem.idPEssoa,
            email: this.editedItem.email,
            telefone: this.editedItem.telefone,
            instituicao_descricao: ls.get('instituicaodescricao')

          }

          var params_table = {
            idFuncionario: params.idFuncionario,
            nome : params.nome,
            bi : params.idPEssoa,
            email:params.email,
          }
        } catch (error) {

        }

        let funcionariojaexiste = this.funcionarios.filter(
          f => f.idPEssoa === this.editedItem.idPEssoa || f.email === this.editedItem.email || f.bilhete === this.editedItem.idPEssoa
        ) // if the id is not there then check for BI in collection before create new record if BI is in the collection. the entry already exist, if not insertOne

        // this.usuariosJaExistentes = this.usuarios.filter(user => user.idPEssoa === params.idPEssoa)
       if (!funcionariojaexiste.length)
        {
          try {
            let cor_mensagem = 'msgError'
            let msg = await axios
              .post('/funcionarioInsertOrUpdate', params)
              .then(res => res.data)
            // this.text = msg[1].insertId

            // verificação da mensagem
            if (msg.length) {
              let erro = msg[0]
              this.text = 'Ocorreu um erro ao tentar efectuar a operação.\n' + erro[0].Message
              cor_mensagem = 'msgError'
              this.progresso = false
            } else {
              this.text = 'Operação efectuada com sucesso.'
              this.funcionarios.unshift(params_table) // Adiciona o objecto a coleção
              cor_mensagem = 'msgSucess'
              this.progresso = false
              this.close()
            }
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: cor_mensagem,
              timeout: 4000
            })
          } catch (error) {
            console.log('eroooo: ' + error)
            this.isLoading = false
            this.progresso = false
            this.text = error.message
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          }
        } else {
          this.$store.dispatch('textMessage', {
            msg: 'O email ou numero de bilhete ja foi utilizado',
            classMessage: 'msgError',
            timeout: 3000
          })
          this.progresso = false
        }
      }
    }
  }

}
</script>
